import React, { Component, Fragment } from 'react'
import DashboardLayout from '../components/Admin/DashboardLayout'
import {
  MDBContainer,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import AdminApi from '../api/admin-api/admin-api'
import moment from 'moment'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'

import './AdminDashboardProspects.scss'

class AdminProspects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      notesModal: false,
      currentNotes: '',
      prospectsList: [],
      items: {
        default: '1',
      },
      data: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Recruiter',
            field: 'recruiter',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Email',
            field: 'email',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Phone',
            field: 'phone',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'City',
            field: 'city',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'State',
            field: 'state',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Claimed On',
            field: 'claimed',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Notes',
            field: 'notes',
            sort: 'disabled',
            width: 150,
          },
        ],
        rows: [],
      },
    }
  }

  componentDidMount() {
    this.fetchProspectsByStatus('claimed')
  }

  togglePills = (type, tab) => e => {
    e.preventDefault()
    if (!this.state.loading) {
      if (this.state.items[type] !== tab) {
        let items = { ...this.state.items }
        items[type] = tab
        this.setState({
          items,
        })
        if (tab === '1') {
          this.fetchProspectsByStatus('claimed')
        }
        if (tab === '2') {
          this.fetchProspectsByStatus('unclaimed')
        }
        if (tab === '3') {
          this.fetchProspectsByStatus('enrolled')
        }
      }
    }
  }

  // resource data API
  fetchProspectsByStatus = async status => {
    this.setState({ loading: true })

    try {
      const result = await AdminApi.getProspectByStatus(status)
      const prospects = result?.data?.data || []

      this.setState({ prospectsList: prospects }, () => {
        this.setState(
          {
            data: { ...this.state.data, rows: [] },
          },
          () => {
            this.setRows()
            this.setState({ loading: false })
          }
        )
      })
    } catch (error) {
      this.setState({ loading: false })
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
    }
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { prospectsList } = this.state
    if (prospectsList && prospectsList.length) {
      let rows = prospectsList.map(row => {
        const { pro_city, pro_claimed_on, pro_email, pro_fname, pro_notes, pro_phone, pro_recruiter, pro_state } = row
        const self = this

        function viewNotes() {
          self.setState({ currentNotes: pro_notes })
          self.confirm_notes({ viewdata: row })
        }

        const viewClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={viewNotes}>
              <MDBIcon icon='pencil-alt' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const claimedOn = (
          <span data-searchvalue={pro_claimed_on ? moment(pro_claimed_on).format('YYYY/MM/DD') : ''}>
            {pro_claimed_on ? moment(pro_claimed_on).format('MM/DD/YYYY') : 'N/A'}
          </span>
        )

        return {
          name: `${pro_fname}`,
          recruiter: pro_recruiter,
          email: pro_email,
          phone: pro_phone,
          city: pro_city,
          state: pro_state,
          claimed: claimedOn,
          notes: viewClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  confirm_notes = data => {
    this.confirm_toggle(data)
  }

  confirm_toggle = (data = {}) => {
    this.setState({ notesModal: !this.state.notesModal, ...data })
  }

  render() {
    toast.configure()
    const { loading, data, notesModal } = this.state

    const activeTab = this.state.items['default']
    const sectionTitles = { 1: 'Claimed Prospects', 2: 'Unclaimed Prospects', 3: 'Enrolled Prospects' }

    return (
      <Fragment>
        <DashboardLayout>
          <main id='AdminDashboardProspects' className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h2>USABG Prospects</h2>
              <hr />
              <ul className='nav mt-5 nav-pills'>
                <li className='nav-item'>
                  <a
                    href='#'
                    className={`nav-link${activeTab === '1' ? ' active' : ''}`}
                    onClick={this.togglePills('default', '1')}
                  >
                    Claimed
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    href='#'
                    className={`nav-link${activeTab === '2' ? ' active' : ''}`}
                    onClick={this.togglePills('default', '2')}
                  >
                    Unclaimed
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    href='#'
                    className={`nav-link${activeTab === '3' ? ' active' : ''}`}
                    onClick={this.togglePills('default', '3')}
                  >
                    Enrolled
                  </a>
                </li>
              </ul>
              {loading ? (
                <h5 className='mt-4'>Loading...</h5>
              ) : (
                <div className='tab-content'>
                  <div className='tab-pane active content-wrapper'>
                    <h3>{sectionTitles[activeTab]}</h3>
                    <MDB4Datatable
                      sortRows={['claimed']}
                      striped
                      bordered
                      small
                      data={data}
                      className='text-capitalize'
                    />
                  </div>
                </div>
              )}

              <MDBModal open={notesModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Notes</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div>{this.state.currentNotes}</div>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminProspects
